export default "__VITE_ASSET__BgV439yC__"